import { userProgramSaga } from './userProgram'

export default function* orderSaga() {
  yield userProgramSaga()
}
